import React from "react";
import './FloatingMenu.css'
import {
  NavLink
} from "react-router-dom";
import { useMsal } from "@azure/msal-react";
function FloatingMenu() {             
const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let loggedInEnterpriseId = "";
    if (activeAccount)
        loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    const allowedUsersForContibution = [
        "aluru.akash",
        "ankur.e.mishra",
        "h.srinivasan",
        "jeevadharani.ramanan",
        "arpita.m.singh",
        "uma.rani.battu",
        "reshmi.haridas.m",
        "aayushi.bharti",
        "varsha.a.tyagi",
    ];
    return (
        <div className="iconContainer">     
            {allowedUsersForContibution.includes(loggedInEnterpriseId) && (   
            <button className="iconBtn icon1">
                 <NavLink
                to="/analytics"
                >
                <img src={process.env.PUBLIC_URL +"/images/Home/Analytics-icon.png"} alt="oracle-icon" />
                <span>Analytics</span>
                </NavLink>
            </button>
             )}
        </div> 
    )
}

export default  FloatingMenu